<!-- 模块-兑换记录 -->
<template>
  <div>
    <van-popup class="popup" v-model="ifShow" position="right">
    <v-touch @swiperight="ifShow = false">
      <div style="display:flex;background:#fff;padding:15px" >
        <van-image width="60%" height="3rem" src="https://maximum_api.bei-lin.cn/wechat_oa/weida.png"/>
        <van-row style="line-height:23px;margin-left:15px">
          <van-col span="24" style="color:#333">兑换成功</van-col>
          <van-col span="24" style="font-size:13px;color:#aaa">维达抽纸超韧3层M码120抽24包整箱装</van-col>
          <van-button color="#1cbbb4" round size="small" style="margin-top:7px">到店领取</van-button>
        </van-row>
      </div>
    </v-touch>
    </van-popup>
  </div>
</template>

<script>
export default {
  data () {
    return {
      ifShow: false
    }
  },

  methods: {
    // show (data) {
    //   this.ifShow = true
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inte_store/records.vue